import PropTypes from 'prop-types';
import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from 'shared/AppContext';
import storage from 'shared/storage';

// Moon icon SVG
const MoonIcon = ({ size = 20, color = 'currentColor' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

// Sun icon SVG
const SunIcon = ({ size = 20, color = 'currentColor' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="5" stroke={color} strokeWidth="2" fill="none" />
    <line
      x1="12"
      y1="1"
      x2="12"
      y2="3"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="12"
      y1="21"
      x2="12"
      y2="23"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="4.22"
      y1="4.22"
      x2="5.64"
      y2="5.64"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="18.36"
      y1="18.36"
      x2="19.78"
      y2="19.78"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="1"
      y1="12"
      x2="3"
      y2="12"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="21"
      y1="12"
      x2="23"
      y2="12"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="4.22"
      y1="19.78"
      x2="5.64"
      y2="18.36"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="18.36"
      y1="5.64"
      x2="19.78"
      y2="4.22"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const ThemeToggle = ({ color = 'white', showLabel = true }) => {
  const { state } = useContext(AppContext);
  const [theme, setTheme] = useState(() => {
    return state?.theme || storage.get('theme') || 'light';
  });

  useEffect(() => {
    // Sync with AppContext theme if it changes
    if (state?.theme && state.theme !== theme) {
      setTheme(state.theme);
    }
  }, [state.theme, theme]);

  return (
    <>
      <div style={{ marginRight: 10, width: 20 }}>
        {theme === 'light' ? (
          <MoonIcon size={20} color={color} />
        ) : (
          <SunIcon size={20} color={color} />
        )}
      </div>{' '}
      {showLabel && (theme === 'light' ? 'Dark Mode' : 'Light Mode')}
    </>
  );
};

ThemeToggle.propTypes = {
  color: PropTypes.string,
  showLabel: PropTypes.bool,
};

export default ThemeToggle;
